var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMhoUpArrowWhiteIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 10,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 19,
    height: 10
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M453.706 650.369C454.196 649.881 454.989 649.875 455.486 650.35L455.501 650.369 462.223 656.981 468.943 650.369C469.434 649.881 470.227 649.875 470.723 650.35L470.739 650.369C471.23 650.85 471.236 651.631 470.754 652.119L470.739 652.131 463.12 659.631C462.629 660.119 461.837 660.125 461.34 659.65L461.324 659.631 453.706 652.131C453.209 651.644 453.209 650.856 453.706 650.369Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.11109,
    fill: "#FFFFFF",
    transform: "matrix(-1.06875 -1.22465e-16 1.30885e-16 -1 503.5 660)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMhoUpArrowWhiteIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mho-up-arrow-white-icon.b34967f03ef9a3fdc56eb82cef0829e1.svg";